// import React from "react";
// import I1 from "../../Images/New/RightSoft/1.png";
// import I2 from "../../Images/New/RightSoft/2.png";
// import I3 from "../../Images/New/RightSoft/3.png";
// import I4 from "../../Images/New/RightSoft/4.png";
// import I5 from "../../Images/New/RightSoft/5.png";
// import I6 from "../../Images/New/RightSoft/6.png";
// import I7 from "../../Images/New/RightSoft/7.png";
// import I8 from "../../Images/New/RightSoft/8.png";

// function RightSoft() {
//   const [expandedIndex, setExpandedIndex] = React.useState(-1);

//   const handleMouseEnter = (index) => {
//     setExpandedIndex(index);
//   };

//   const handleMouseLeave = () => {
//     setExpandedIndex(-1);
//   };

//   const faqDataLeft = [
//     {
//       question: "Generate & Upload GST Returns easily",
//       answer:
//         "Input Data, Reconcile, Upload JSON, Digital sign/EVC and submit GSTR 1 and GSTR 3B to GST Portal",
//       img: I1
//     },
//     {
//       question: "Analysis Reports",
//       answer:
//         `Party-wise / Invoice wise / Consolidated reconciliation reports of GSTR 2A & GSTR 2B with accounts, ITC Comparison Reports`,
//         img: I2
//     },
//     {
//       question: "GST Reconciliation",
//       answer:
//         "Reconcile GSTR 2A/2B, Table-8A & GSTR-1 with Books Data, GSTR-3B & GSTR 2A/2B, GSTR-3B & GSTR-1 ",
//         img: I3
//     },
//     {
//       question: "Comprehensive Dashboard",
//       answer:
//         "File all returns – GSTR 1, 3B, 4, CMP08, 9, 9C etc. from a single comprehensive dashboard without navigation hassles",
//         img: I4
//     },
//     {
//       question: "Data Import-Export",
//       answer:
//         "Import data from Tally, Govt. Excel sheets, Default Excel sheet. Export the report data in a click ",
//         img: I5
//     },
//     {
//       question: "Input Tax Credits",
//       answer:
//         "Calculate accurate ITC with the intelligent reconciliation module ",
//         img: I6
//     },
//     {
//       question: "Customer Support",
//       answer:
//         "Dedicated support team is available to assist with any functional or technical queries and suggestions from customers. ",
//         img: I7
//     },
//     {
//       question: "Data Privacy",
//       answer:
//         "We recognize the sensitivity of our clients' data. With EasyGST, all of your data is kept solely on your computer, ensuring that you retain complete control over your data at all times.",
//         img: I8
//     },
//   ];


import React from "react";
import I1 from "../../Images/New/RightSoft/1.png";
import I2 from "../../Images/New/RightSoft/2.png";
import I3 from "../../Images/New/RightSoft/3.png";
import I4 from "../../Images/New/RightSoft/4.png";
import I5 from "../../Images/New/RightSoft/5.png";
import I6 from "../../Images/New/RightSoft/6.png";
import I7 from "../../Images/New/RightSoft/7.png";
import I8 from "../../Images/New/RightSoft/8.png";
import Right from "../../Images/RightSvg.svg";

function RightSoft() {
  const [expandedIndex, setExpandedIndex] = React.useState(-1);

    const handleMouseEnter = (index) => {
      setExpandedIndex(index);
    };

    const handleMouseLeave = () => {
      setExpandedIndex(-1);
    };

  let ListItem = React.memo(({ text }) => (
    <li className="flex gap-x-3 items-start text-lg">
      <img src={Right} className="mt-[6px]" alt="" />
      <span>
        <strong className="font-semibold text-gray-900"> {text} </strong>
      </span>
    </li>
  ));

  const faqDataLeft = [
    {
      question: "Generate & Upload GST Returns easily",
      answer: [
        "Input Data, Reconcile, Upload JSON, Digital sign/EVC",
        "Submit GSTR 1 and GSTR 3B to GST Portal",
      ],
      img: I1,
    },
    {
      question: "Analysis Reports",
      answer: [
        "Party-wise / Invoice wise / Consolidated reconciliation reports of GSTR 2A & GSTR 2B with accounts",
        "ITC Comparison Reports",
      ],
      img: I2,
    },
    {
      question: "GST Reconciliation",
      answer: [
        "Reconcile GSTR 2A/2B, Table-8A & GSTR-1 with Books Data",
        "GSTR-3B & GSTR 2A/2B",
        " GSTR-3B & GSTR-1",
      ],
      img: I3,
    },
    {
      question: "Comprehensive Dashboard",
      answer: [
        "File all returns – GSTR 1, 3B, 4, CMP 08, 9, 9C etc. from a single comprehensive dashboard without navigation hassles",
      ],
      img: I4,
    },
    {
      question: "Data Import-Export",
      answer: [
        "Import data from Tally, Govt. Excel sheets, Default Excel sheet.",
        " Export the report data in a click",
      ],
      img: I5,
    },
    {
      question: "Input Tax Credits",
      answer: [
        "Calculate accurate ITC with the intelligent reconciliation module",
      ],
      img: I6,
    },
    {
      question: "Customer Support",
      answer: [
        "Dedicated support team is available to assist with any functional or technical queries and suggestions from customers.",
      ],
      img: I7,
    },
    {
      question: "Data Privacy",
      answer: [
        "We recognize the sensitivity of our client data. With EasyGST, All of your data is kept solely on your computer, Ensuring that you retain complete control over your data at all times",
      ],
      img: I8,
    },
  ];

  return (
    <div className="sm:flex py-20 sm:px-10 bg-[#f1f5f8] relative items-center">
      <div className="w-full px-5 flex justify-center">
        <div className="bg-white border-2 rounded-2xl shadow-xl px-3 sm:px-12 pb-6 sm:pb-10 w-full max-w-7xl">
          <div className="flex flex-col items-center">
            <h2 className="font-bold text-5xl mt-10 tracking-tight">
              Choosing the Right Software is{" "}
              <span className="text-[#519980]"> half the work done</span>{" "}
            </h2>
          </div>
          <div className="grid grid-cols-1 items-start sm:grid-cols-2 px-3 sm:px-0 w-full mt-20 gap-4 ">
            {faqDataLeft.map((faq, index) => (
              <div
                key={index}
                className={`faq-item bg-white border-2 rounded-xl overflow-hidden ${
                  expandedIndex === index ? "border-[#7decc6]" : ""
                }`}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                <summary className="flex justify-between text-xl items-center font-medium cursor-pointer list-none bg-white p-4">
                  <span className="flex items-center">
                    <img className="h-12 w-12 mr-5" src={faq.img} alt="" />
                    <span>{faq.question}</span>
                  </span>
                  <span className="transition bg-[#7decc6] rounded-full p-2">
                    <svg
                      fill="none"
                      height="24"
                      shapeRendering="geometricPrecision"
                      stroke="white"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M6 9l6 6 6-6"></path>
                    </svg>
                  </span>
                </summary>
                {expandedIndex === index && (
                  <div className="answer p-4 bg-white">
                    {faq.answer.map((item, idx) => (
                      <ListItem key={idx} text={item} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RightSoft;

